class CollectionFilterTabs extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.tabs = this.querySelectorAll('.collection-filter-tabs__item');
    this.inputs = this.querySelectorAll('.collection-filter-tabs__item-input');

    if (this.tabs.length === 0) return;

    const currentPath = window.location.pathname;
    let matchedTab = false;

    this.tabs.forEach((tab, index) => {
      const tabUrl = tab.dataset.collectionFilterTabs;
      if (tabUrl && currentPath === new URL(tabUrl, window.location.origin).pathname) {
        this.inputs[index].checked = true;
        matchedTab = true;
      }
    });

    // If no tab matches current URL, set first tab as active by default
    if (!matchedTab && this.inputs[0]) {
      this.inputs[0].checked = true;
    }

    // Add click handlers to all tabs
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.handleTabClick(tab, index));
    });

    window.addEventListener('popstate', (event) => {
      if (event.state && event.state.path) {
        this.tabs.forEach((tab, index) => {
          const tabUrl = tab.dataset.collectionFilterTabs;
          if (tabUrl === event.state.path) {
            this.inputs[index].checked = true;
            this.loadCollection(event.state.path, false);
          }
        });
      }
    });

    if (!matchedTab && this.tabs[0]) {
      const firstUrl = this.tabs[0].dataset.collectionFilterTabs;
      if (firstUrl) {
        this.loadCollection(this.preserveScentParam(firstUrl));
      }
    }
  }

  preserveScentParam(url) {
    const scentParam = new URLSearchParams(window.location.search).get('scent');
    if (!scentParam) return url;

    const urlObj = new URL(url, window.location.origin);
    urlObj.searchParams.set('scent', scentParam);
    return urlObj.pathname + urlObj.search;
  }

  handleTabClick(tab, index) {
    const url = tab.dataset.collectionFilterTabs;
    if (!url) return;

    this.inputs[index].checked = true;
    this.loadCollection(this.preserveScentParam(url));
  }

  loadCollection(url, updateURL = true) {
    if (window.location.pathname.includes('pages/')) updateURL = false; // on quiz results page do not update URL
    const productGridContainer = document.getElementById('ProductGridContainer');
    const facetsWrapper = document.getElementById('main-collection-filters');

    if (!productGridContainer) {
      console.error('Product grid container not found');
      return;
    }

    const loadingOverlay = productGridContainer.querySelector('.loading-overlay');
    loadingOverlay?.classList.add('loading');

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProductGridContainer = doc.getElementById('ProductGridContainer');

        if (newProductGridContainer) {
          productGridContainer.innerHTML = newProductGridContainer.innerHTML;
        }

        if (facetsWrapper) {
          const newFacetsWrapper = doc.getElementById('main-collection-filters');
          if (newFacetsWrapper) {
            facetsWrapper.innerHTML = newFacetsWrapper.innerHTML;
            this.reinitializeFacets(facetsWrapper);
          }
        }

        if (newProductGridContainer) {
          this.applyScentFilterBeforeDisplay();
          this.reinitializeScripts(productGridContainer);
        }

        this.updateCollectionBanner(doc);
        this.updateHeaderMenu(url);

        if (updateURL) {
          window.history.pushState({ path: url }, '', url);
        }
      })
      .catch((error) => {
        console.error('Error loading collection:', error);
      })
      .finally(() => {
        loadingOverlay?.classList.remove('loading');
      });
  }

  applyScentFilterBeforeDisplay() {
    const urlParams = new URLSearchParams(window.location.search);
    const scentParam = urlParams.get('scent');

    if (!scentParam || scentParam === 'all') return;

    const productGrid = document.querySelector('#product-grid');
    if (!productGrid) return;

    const productItems = productGrid.querySelectorAll('.grid__item');
    const normalizedFilterTag = this.handleize(scentParam);

    const visibleCount = this.filterProductsByScentTag(productItems, normalizedFilterTag);
    this.updateProductCountDisplay(visibleCount);
    this.updateFacetCounts(productItems);
    this.hidePagination();
  }

  filterProductsByScentTag(productItems, filterTag) {
    let visibleCount = 0;

    productItems.forEach((item) => {
      const tags = item.getAttribute('data-product-tags');
      const productTags = tags ? tags.split(',').map((tag) => tag.trim()) : [];
      const hasTag = productTags.some((tag) => tag === filterTag);

      item.style.display = hasTag ? '' : 'none';
      if (hasTag) visibleCount++;
    });

    return visibleCount;
  }

  updateProductCountDisplay(count) {
    const productCount = document.querySelector('#ProductCountDesktop');
    if (productCount) {
      const productText = count === 1 ? 'product' : 'products';
      productCount.textContent = ` ${count} ${productText}`;
    }
  }

  updateFacetCounts(productItems) {
    const visibleCount = Array.from(productItems).filter((item) => item.style.display !== 'none').length;
    const facetLabels = document.querySelectorAll('.facet-checkbox span[aria-hidden="true"]');

    facetLabels.forEach((label) => {
      if (label.textContent.includes('In stock')) {
        label.textContent = `In stock (${visibleCount})`;
      }
    });
  }

  hidePagination() {
    const pagination = document.querySelector('.pagination-wrapper');
    if (pagination) pagination.style.display = 'none';
  }

  handleize(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  reinitializeScripts(container) {
    const quickAddButtons = container.querySelectorAll('quick-add-button');
    quickAddButtons.forEach((button) => {
      if (button.connectedCallback) {
        button.connectedCallback();
      }
    });

    if (typeof CollectionScentFilter !== 'undefined') {
      new CollectionScentFilter();
    }
  }

  reinitializeFacets(container) {
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.setListeners) {
      FacetFiltersForm.setListeners();
    }
    const showMoreButtons = container.querySelectorAll('show-more-button');
    showMoreButtons.forEach((button) => {
      if (button.connectedCallback) {
        button.connectedCallback();
      }
    });
  }

  updateCollectionBanner(doc) {
    const selectors = ['.banner', '.collection-hero', '.slideshow'];

    selectors.forEach((selector) => {
      const current = document.querySelector(selector);
      const newElement = doc.querySelector(selector);
      if (current && newElement) {
        current.innerHTML = newElement.innerHTML;
      }
    });
  }

  updateHeaderMenu(url) {
    const urlPath = new URL(url, window.location.origin).pathname;

    const headerMenuItems = document.querySelectorAll('.header__menu-item');

    headerMenuItems.forEach((menuItem) => {
      const menuItemHref = menuItem.getAttribute('href');

      if (menuItemHref) {
        const menuItemPath = new URL(menuItemHref, window.location.origin).pathname;
        const span = menuItem.querySelector('span');

        if (menuItemPath === urlPath) {
          menuItem.setAttribute('aria-current', 'page');
          if (span) {
            span.classList.add('header__active-menu-item');
          }
        } else {
          menuItem.removeAttribute('aria-current');
          if (span) {
            span.classList.remove('header__active-menu-item');
          }
        }
      }
    });
  }
}

if (!customElements.get('collection-filter-tabs')) {
  customElements.define('collection-filter-tabs', CollectionFilterTabs);
}
